import { observer } from 'mobx-react-lite'
import { Modal } from 'component/Modal'
import { ComboCartFiltersScreen } from './ComboCartFiltersScreen'
import { Button } from 'component/Button'
import { Typo } from 'component/Typo'
import { i18n } from 'i18n'
import { comboCartStore } from 'page/catalog/store/ComboCartStore'
import css from './ComboCartFiltersModal.module.scss'
import { Icon } from 'icon/Icon'
import { Space } from 'component/Space'

interface ComboCartFiltersModalProps {
  open: boolean
  onClose: () => void
  currentStep: 'top' | 'bottom'
}

export const ComboCartFiltersModal = observer(
  ({ open, onClose, currentStep }: ComboCartFiltersModalProps) => {
    const filters =
      currentStep === 'top'
        ? comboCartStore.topFilters
        : comboCartStore.bottomFilters

    const { brands, colors } = filters

    const resetAllFilters = () => {
      if (currentStep === 'top') {
        comboCartStore.clearTopFilters()
      } else {
        comboCartStore.clearBottomFilters()
      }
    }

    const hasActiveFilters = () => {
      return (
        brands.value.length > 0 ||
        colors.value.length > 0
      )
    }

    return (
      <Modal
        open={open}
        onCancel={onClose}
        fullscreen
        white
        closeButton={false}
        oh
      >
        <div className={css.modalHeader}>
          <Button simple action={onClose}>
            <Space gap={6}>
              <Icon className={css.arrow} name="arrow_upward" size={16} />
              {i18n('combo.Back')}
            </Space>
          </Button>
          <Typo size={16} bold className={css.modalTitle}>
            {i18n('combo.Filters')}
          </Typo>
          <Button simple action={resetAllFilters} disabled={!hasActiveFilters()}>
            {i18n('combo.Reset')}
          </Button>
        </div>
        <ComboCartFiltersScreen currentStep={currentStep} onApply={onClose} />
      </Modal>
    )
  }
)
